module.exports = __webpack_public_path__ + "static/media/task-notification-error.e3c52b18.svg";